import React from "react";

const ProfileAccount = () => {
  return <div>ProfileAccount</div>;
};

export default ProfileAccount;
